import { render } from "./SmokeFromLightExposureRole.vue?vue&type=template&id=618b29e1&scoped=true&ts=true"
import script from "./SmokeFromLightExposureRole.vue?vue&type=script&lang=ts"
export * from "./SmokeFromLightExposureRole.vue?vue&type=script&lang=ts"

import "./SmokeFromLightExposureRole.vue?vue&type=style&index=0&id=618b29e1&scoped=true&lang=css"
import "./SmokeFromLightExposureRole.vue?vue&type=style&index=1&id=618b29e1&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-618b29e1"]])

export default __exports__